import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitIntercomPage } from './housing-unit-intercom';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HousingUnitIntercomPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitIntercomPage),
	],
})
export class HousingUnitIntercomPageModule { }



// WEBPACK FOOTER //
// ./src/pages/housing-unit-intercom/housing-unit-intercom.module.ts